export enum QueryKeys {
  ACCEPT_AGREEMENT = 'accept_agreement',
  AUTHENTICATE = 'authenticate',
  CHANNELS = 'channels',
  EULA = 'EULA',
  FLIGHTROOM = 'flightroom',
  FLIGHTROOMS = 'flightrooms',
  GET_ATTACHMENT = 'get_attachment',
  MENTIONS = 'mentions',
  MESSAGES = 'messages',
  MUTE_FLIGHTROOM = 'mute_flightroom',
  NOTIFICATIONS = 'notifications',
  QUICK_REPLIES = 'quick_replies',
  RESOLVE_EXTERNAL_ROOM = 'resolve_external_room',
  ROLE = 'role',
  ROLES = 'roles',
  SEARCH_FLIGHTROOM = 'search_flightroom',
  SETTINGS = 'settings',
  SMART_ACTION = 'smart_action',
  SMART_ACTIONS = 'smart_actions',
  SYSTEM_MESSAGES = 'systemMessages',
  TASKS = 'tasks',
  UPDATE_WORKSTATION = 'update_workstation',
  UPLOAD_ATTACHMENT = 'upload_attachment',
  USERS = 'users',
  VERSION = 'version',
  WORKSTATION = 'workstation',
}
